"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSummaryConfig = void 0;
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var partiallyApplyComponent_1 = __importDefault(require("@CommonFrontend/QuoteV2/Components/partiallyApplyComponent"));
var QuoteSummary_1 = __importDefault(require("@CommonFrontend/Public/Widgets/QuoteSummary"));
var QuoteSummaryWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSummary/QuoteSummaryWidget");
exports.QuoteSummaryConfig = {
    type: "quoteSummary",
    tokenType: {},
    publicRender: function QuoteSummaryWidget(_a) {
        var _b, _c, _d, _e, _f;
        var attributes = _a.attributes, token = _a.token;
        return server_1.default.renderToString(react_1.default.createElement((0, partiallyApplyComponent_1.default)(QuoteSummary_1.default, {
            attributes: attributes,
            settings: {
                showFeatureLists: (_b = token.showFeatureLists) !== null && _b !== void 0 ? _b : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showFeatureLists,
                showTextItems: (_c = token.showTextItems) !== null && _c !== void 0 ? _c : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showTextItems,
                showPlanSectionHeaders: (_d = token.showPlanSectionHeaders) !== null && _d !== void 0 ? _d : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showPlanSectionHeaders,
                compactLineItemDescriptions: (_e = token.compactLineItemDescriptions) !== null && _e !== void 0 ? _e : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactLineItemDescriptions,
                compactSectionHeaders: (_f = token.compactSectionHeaders) !== null && _f !== void 0 ? _f : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactSectionHeaders,
            },
        })));
    },
    traits: {},
};
